import "./cuenta_cobrar.css"
export { default as ListadoCuentaCobrar } from "./Listado";
export { default as ReciboCuentaCobrar } from "./Recibo";
